import {
  type CertificateCollection,
  certificateCollectionSchema,
  type Certificate,
  certificateSchema, certificateFilterSchema, type CertificateFilter,
} from '@/types/Wiser/certificate.ts'

import { createRestApi, type HttpClient, type ModelApi } from '@jantm/model-core'

export type CertificateApi = ModelApi<Certificate, CertificateCollection, CertificateFilter>

/**
 * The HTTP client is injected rather than imported so this package never pins
 * an axios instance, a base URL, or an auth interceptor — the host application
 * owns all three.
 */
export function createCertificateApi(
  client: HttpClient,
  endpoint = '/wiser/certificaat',
): CertificateApi {
  return createRestApi({
    client,
    endpoint,
    schema: certificateSchema,
    collectionSchema: certificateCollectionSchema,
    filterSchema: certificateFilterSchema,
  })
}
